module.exports = __webpack_public_path__ + "static/media/12-iveco.91769ab4.jpg";